// XR reparents the camera to PlayerLocal.xrRig; the desktop rig then stays behind.
// base.position follows the interpolated PhysX capsule, including room-scale movement.
export function localPlayerPosition(world) {
  return world.xr?.session ? world.entities?.player?.base?.position || world.rig.position : world.rig.position
}
